const title = "后台模板后台模板后台模板";
const logo = require("../assets/images/public/logo.png");
// const baseUrl = 'http://120.46.163.19:8098'; // 测试环境
const baseUrl = "https://snn.allynav.com/v1"; // 正式环境

// 默认皮肤
const defaultSkin = [
  {
    label: "默认",
    topColor: "#ffffff",
    topBg: ["#539D56", "#357437"],
    sideColor: "#265628",
    sideBg: ["#ffffff", "#ffffff"],
    isDefault: true,
    checked: true,
  },
];

// 管理端侧边栏
// const meunNav = [
//   {
//     route: "positionMap",
//     meta: {
//       title: "站点地图",
//       sort: 1,
//       hidden: false,
//       isDetail: false,
//       oneChildrenHidden: true,
//     },
//     children: [
//       {
//         route: "positionMap",
//         meta: {
//           title: "站点地图",
//           sort: 1,
//           hidden: false,
//           hiddenSide: false,
//           isDetail: false,
//         },
//       },
//     ],
//   },
//   {
//     route: "baseStation",
//     meta: {
//       title: "基站管理",
//       sort: 1,
//       hidden: false,
//       isDetail: false,
//       oneChildrenHidden: true,
//     },
//     children: [
//       {
//         route: "baseStation",
//         meta: {
//           title: "基站管理",
//           sort: 1,
//           hidden: false,
//           hiddenSide: false,
//           isDetail: false,
//         },
//       },
//     ],
//   },
//   {
//     route: "onlineNtrip",
//     meta: {
//       title: "在线NTRIP用户",
//       sort: 1,
//       hidden: false,
//       isDetail: false,
//       oneChildrenHidden: true,
//     },
//     children: [
//       {
//         route: "onlineNtrip",
//         meta: {
//           title: "在线NTRIP用户",
//           sort: 1,
//           hidden: false,
//           hiddenSide: false,
//           isDetail: false,
//         },
//       },
//     ],
//   },
//   {
//     route: "userManage",
//     meta: {
//       title: "用户管理",
//       sort: 1,
//       hidden: false,
//       isDetail: false,
//       oneChildrenHidden: true,
//     },
//     children: [
//       {
//         route: "userManage",
//         meta: {
//           title: "用户管理",
//           sort: 1,
//           hidden: false,
//           hiddenSide: false,
//           isDetail: false,
//         },
//       },
//     ],
//   },
//   {
//     route: "loginSet",
//     meta: {
//       title: "登录用户管理",
//       sort: 1,
//       hidden: false,
//       isDetail: false,
//       oneChildrenHidden: true,
//     },
//     children: [
//       {
//         route: "loginSet",
//         meta: {
//           title: "登录用户管理",
//           sort: 1,
//           hidden: false,
//           hiddenSide: false,
//           isDetail: false,
//         },
//       },
//     ],
//   },
// ];
const meunNav = [];
// 导航栏模式
const navMode = "default"; // default 只有侧边栏  sideTop 侧边和顶部都有
// 布局模式
const layoutMode = "navFull"; // navFull  顶部导航栏通栏   sideFull 侧边导航栏通栏
// 是否开启页面缓存
const useRouteCache = true;

// 表格自定义列
const tableItemName = "open_tableItem";
// 本地皮肤缓存名称
const skinName = "open_skin";
// 本地token缓存名称
const tokenName = "open_token";
// 本地重载缓存
const reLoadName = "open_reload";
// 本地翻译标识
const langFlag = "localOpenLangFlag";
// 本地菜单信息列表
const menuListName = "openMenuList";
// 本地过期时间
const expireTime = "openExpireAt";
// 本地翻译可选项
const langEnum = [
  {
    label: "English",
    type: "en",
    isCheck: false,
    icon: require("../assets/images/public/en.png"),
    alias: "英文",
  },
  {
    label: "中文",
    type: "zh",
    isCheck: false,
    icon: require("../assets/images/public/zh.png"),
    alias: "中文",
  },
  {
    label: "русский язык",
    type: "ru-RU",
    isCheck: false,
    icon: require("../assets/images/public/ru.png"),
    alias: "俄语",
  },
  {
    label: "Türkçe",
    type: "tr-TR",
    isCheck: false,
    icon: require("../assets/images/public/tr.png"),
    alias: "土耳其语",
  },
  // {
  //   label: "Español",
  //   type: "es",
  //   isCheck: false,
  //   icon: require("../assets/images/public/es.png"),
  //   alias: "西班牙语",
  // },
];
export {
  title,
  baseUrl,
  meunNav,
  tokenName,
  skinName,
  defaultSkin,
  reLoadName,
  navMode,
  tableItemName,
  useRouteCache,
  layoutMode,
  logo,
  langFlag,
  langEnum,
  menuListName,
  expireTime,
};
